import {criarDownloadPdfImpl, downloadArquivosImpl} from 'platformImpl';
import store from "../../store";

export const criarDownloadPdf = (data, fileName) => {
    const type = store.getState().drawerPDF.type;
    return criarDownloadPdfImpl(data, fileName, type);
};

export const downloadArquivos = (data, fileName) => {
    const type = store.getState().drawerPDF.type;
    downloadArquivosImpl(data, fileName, type);
};

export const cdvMimeType = function(ext){
    switch(ext) {
        case "jpg": return "image/jpeg";
        case "jpeg": return "image/jpeg";
        case "jpe": return "image/jpeg";
        case "png": return "image/png";
        case "bmp": return "image/bmp";
        case "pdf": return "application/pdf";
        case "zip": return "application/zip";
        default: return "application/pdf";
    }
};

export const criarDownloadXml = (data, fileName) => {
    try {
        var decodedString = String.fromCharCode.apply(null, new Uint8Array(data));
        var obj = JSON.parse(decodedString);
        if ('result' in obj) {
            return obj.result;
        }
    } catch (e) {
        var blob = new Blob([data], {
            type: "application/xml"
        });
        //Dispara o Download
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        return false;
    }
};

//FUNCOES AUXILIARES:

export function dataURIToBlob(dataURI, extension) {
    var binStr = atob(dataURI.split(',')[1]),
        len = binStr.length,
        arr = new Uint8Array(len),
        mimeString = extension ? extension : dataURI.split(',')[0].split(':')[1].split(';')[0]
    for (var i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], {
        type: mimeString
    });
}

// http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
/* utf.js - UTF-8 <=> UTF-16 convertion
 *
 * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
 * Version: 1.0
 * LastModified: Dec 25 1999
 * This library is free.  You can redistribute it and/or modify it.
 */
export const Utf8ArrayToStr = (array) => {
    var out, i, len, c;
    var char2, char3;
    out = "";
    len = array.length;
    i = 0;
    while(i < len) {
        c = array[i++];
        switch(c >> 4)
        {
            case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
            // 0xxxxxxx
            out += String.fromCharCode(c);
            break;
            case 12: case 13:
            // 110x xxxx   10xx xxxx
            char2 = array[i++];
            out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
            break;
            case 14:
                // 1110 xxxx  10xx xxxx  10xx xxxx
                char2 = array[i++];
                char3 = array[i++];
                out += String.fromCharCode(((c & 0x0F) << 12) |
                    ((char2 & 0x3F) << 6) |
                    ((char3 & 0x3F) << 0));
                break;
        }
    }
    return out;
}

export const isJson = content => {
    try {
        JSON.stringify(content);
    } catch (e) {
        return false;
    }

    return true;
}